import i18n from '@/locales/i18n'
import { ADMIN_PRODUCTION_LINE_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ADMIN_PRODUCTION_LINE_LIST_ROUTE_NAME = 'adminProductionLinesList'
export const ADMIN_PRODUCTION_LINE_DETAIL_ROUTE_NAME = 'adminProductionLinesDetail'

const routes: RouteType[] = [
    {
        path: ADMIN_PRODUCTION_LINE_ROUTES.baseUrl,
        name: ADMIN_PRODUCTION_LINE_LIST_ROUTE_NAME,
        component: () =>
            import('@/views/AdminView/AdminProductionLinesView/AdminProductionLinesView.vue'),
        meta: {
            title: i18n.global.t('menu.adminProductionLines'),
            authRequired: true
        }
    },
    {
        path: ADMIN_PRODUCTION_LINE_ROUTES.detailUrl,
        name: ADMIN_PRODUCTION_LINE_DETAIL_ROUTE_NAME,
        component: () => import('@/views/ProductionLineView/ProductionLineDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.adminProductionLines'),
            authRequired: true
        }
    }
]

export default routes
